
//// wallet integration ////

export const SUCCESS_CONNECTION = 'SUCCESS_CONNECTION'
export const FAILING_CONNECTION = 'FAILING_CONNECTION'
export const ACCOUNTS_CHANGE = 'ACCOUNTS_CHANGE'
export const IS_INSTALLED = 'IS_INSTALLED'
export const IS_NOT_INSTALLED = 'IS_NOT_INSTALLED'

//// Contract functionalities ////

export const CONTRACT_INSTANCE = 'CONTRACT_INSTANCE'
export const BUY_BACK_IN = 'BUY_BACK_IN'
export const NFT_SERIES1_CONTRACT = 'NFT_SERIES1_CONTRACT' 
export const NFT_TOKEN_URI = 'NFT_TOKEN_URI'
export const SERIES1_CONTRACT = 'SERIES1_CONTRACT'
export const IPFS_IMAGE_URL = 'IPFS_IMAGE_URL'
export const WALLET_NFTS = 'WALLET_NFTS'
export const WRAPPED_ETHER_INSTANCE = 'WRAPPED_ETHER_INSTANCE'
export const GLOBAL_STAGE = 'GLOBAL_STAGE'

//// Stages Data ////

export const STAGES_DATA = 'STAGES_DATA'
export const ALL_USERS_DATA = 'ALL_USERS_DATA' 
export const MY_NFT_DATA = 'MY_NFT_DATA' 
export const MY_AVAILABLE_NFT = 'MY_AVAILABLE_NFT'


//// Token Balance ////

export const TOKEN_BALANCE = 'TOKEN_BALANCE'

//// Loader ////

export const LOADER_STATE_TRUE = "LOADER_STATE_TRUE"
export const LOADER_STATE_FALSE = "LOADER_STATE_FALSE"


//// Tresaury Balance ////

export const TRESUARY_BALANCE = "TRESUARY_BALANCE"

//// Latest Stages ////

export const SET_LATEST_STAGES = "SET_LATEST_STAGES"

export const RELOAD_POPUP_TRUE = "RELOAD_POPUP_TRUE"
export const RELOAD_POPUP_FALSE = "RELOAD_POPUP_FALSE"

export const COUNTDOWN_LOADER_TRUE = "COUNTDOWN_LOADER_TRUE"
export const COUNTDOWN_LOADER_FALSE = "COUNTDOWN_LOADER_FALSE"